export default __webpack_public_path__ + "static/media/logo.27227e2e.svg";